// extracted by mini-css-extract-plugin
export default {"image":"Img-module--image--1XToR"};